import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { BalanceVisibilityProvider } from './contexts/BalanceVisibilityContext';
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Login from './pages/public/Login';
import LoginTwoFactor from './pages/public/LoginTwoFactor';
import Register from './pages/public/Register';
import ForgotPassword from './pages/public/ForgotPassword';
import EmailValidation from './pages/public/EmailValidation';

// Internal Pages
import Dashboard from './pages/internal/Dashboard';
import Accounts from './pages/internal/Accounts';
import Transactions from './pages/internal/Transactions';
import TransactionDetail from './pages/internal/TransactionDetail';
import PixList from './pages/internal/PixList';
import PixAdd from './pages/internal/PixAdd';
import PixEdit from './pages/internal/PixEdit';
import PersonalData from './pages/internal/PersonalData';
import PixUpdate from './pages/internal/PixUpdate';
import ChangePassword from './pages/internal/ChangePassword';
import Transact from './pages/internal/Transact';
import Deposit from './pages/internal/Deposit';
import Withdraw from './pages/internal/Withdraw';
import AccountLevel from './pages/internal/AccountLevel';
import AccountLevelStep from './pages/internal/AccountLevelStep';
import AccountHome from './pages/internal/AccountHome';
import AccountLevelInput from './pages/internal/AccountLevelInput';
import AccountLevelConfirmation from './pages/internal/AccountLevelConfirmation';
import WalletList from './pages/internal/WalletList';
import WalletAdd from './pages/internal/WalletAdd';
import WalletEdit from './pages/internal/WalletEdit';
import AccountSecurity from './pages/internal/AccountSecurity';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <BalanceVisibilityProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/login/2fa" element={<LoginTwoFactor />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/valid/:token" element={<EmailValidation />} />
          
          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <ProtectedRoute>
                <Accounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Transactions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions/:externalId"
            element={
              <ProtectedRoute>
                <TransactionDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallets"
            element={
              <ProtectedRoute>
                <WalletList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallets/add"
            element={
              <ProtectedRoute>
                <WalletAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallets/edit/:uuid"
            element={
              <ProtectedRoute>
                <WalletEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transact"
            element={
              <ProtectedRoute>
                <Transact />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transact/deposit"
            element={
              <ProtectedRoute>
                <Deposit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transact/transfer"
            element={
              <ProtectedRoute>
                <Withdraw />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank/pix"
            element={
              <ProtectedRoute>
                <PixList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank/pix/add"
            element={
              <ProtectedRoute>
                <PixAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank/pix/update/:uuid"
            element={
              <ProtectedRoute>
                <PixEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/edit"
            element={
              <ProtectedRoute>
                <PersonalData />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/level"
            element={
              <ProtectedRoute>
                <AccountLevel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/level/:step"
            element={
              <ProtectedRoute>
                <AccountLevelStep />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/level/:level/input"
            element={
              <ProtectedRoute>
                <AccountLevelInput />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/level/:level/confirmation"
            element={
              <ProtectedRoute>
                <AccountLevelConfirmation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank/pix/update/:uuid"
            element={
              <ProtectedRoute>
                <PixUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/security/changepassword"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/security"
            element={
              <ProtectedRoute>
                <AccountSecurity />
              </ProtectedRoute>
            }
          />

          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
      </BalanceVisibilityProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
